import { render, staticRenderFns } from "./UserGraderTambah.vue?vue&type=template&id=2c6069ec&scoped=true&"
import script from "./UserGraderTambah.vue?vue&type=script&lang=js&"
export * from "./UserGraderTambah.vue?vue&type=script&lang=js&"
import style0 from "./UserGraderTambah.vue?vue&type=style&index=0&id=2c6069ec&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6069ec",
  null
  
)

export default component.exports